import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.667 13.75a1.25 1.25 0 0 1 .12 2.494l-.12.006H8.334a1.25 1.25 0 0 1-.12-2.494l.12-.006zm2.5-5a1.25 1.25 0 0 1 0 2.5H5.834a1.25 1.25 0 0 1 0-2.5zm2.5-5a1.25 1.25 0 0 1 0 2.5H3.334a1.25 1.25 0 0 1 0-2.5z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
